import { useDocumentMeta } from '@/hooks/useDocumentMeta';
import HeroCarousel from '@/pages/home/components/HeroCarousel';
import CategoryEntry from '@/pages/home/components/CategoryEntry';
import LatestNews from '@/pages/home/components/LatestNews';
import StarHighlights from '@/pages/home/components/StarHighlights';
import SiteIntro from '@/pages/home/components/SiteIntro';

export default function Home() {
  useDocumentMeta(
    '无颜的月-影视作品资讯与剧情介绍平台',
    '无颜的月影视站提供最新影视资讯、剧情介绍及明星动态，涵盖电影、电视剧资源，满足用户全方位的影视内容需求。'
  );

  return (
    <div className="w-full">
      <section className="w-full border-b border-background-200 bg-background-50">
        <div className="mx-auto w-full max-w-7xl px-4 py-5 md:px-8">
          <h1 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">
            无颜的月影视平台
          </h1>
          <p className="mt-1 text-xs text-foreground-500 md:text-sm">
            最新影视资讯 · 详细剧情介绍 · 明星动态追踪
          </p>
        </div>
      </section>

      <HeroCarousel />
      <CategoryEntry />
      <LatestNews />
      <StarHighlights />
      <SiteIntro />
    </div>
  );
}